import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const StyledBoxCloseButtonContainer = styled(Box)(
  ({ theme }) => ({
    padding: theme.spacing(3),
  }),
);

export default StyledBoxCloseButtonContainer;
